import { Component, OnInit } from '@angular/core';

import { LazyLoadEvent, SelectItem, MessageService, FilterMetadata, FilterMatchMode } from 'primeng/api';
import { Table } from 'primeng/table';

import { BillingDataService } from '../../data-services/billing.service';

import { SecurityUser } from '../../security/security.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { BillingDetailComponent } from './billing.detail.component';

interface DropDown {
  name: string;
  code: string;
}
@Component({
  selector: 'app-billing-list',
  templateUrl: './billing.list.html',
  providers: [MessageService],
  imports: [FormsModule, CommonModule, TableModule, SelectModule, MultiSelectModule, BillingDetailComponent]
})
export class BillingListComponent implements OnInit {
  currentUser: SecurityUser = new SecurityUser();
  isAuthenticated: boolean;

  constructor(private billingDataService: BillingDataService,
    private messageService: MessageService)
  { }

  requisitions;
  totalRecords: number;
  cols: any[];
  filters: { [s: string]: FilterMetadata[] } = { };
  loading: boolean;
  selectedStatus: SelectItem;
  globalFilter: string = '';
  billingStatusList: any[] = [
    { label: 'Pre Billing', value: 'Pre Billing' },
    { label: 'Billing Hold', value: 'Billing Hold' },
    { label: 'Not Billable', value: 'Not Billable' },
    { label: 'Express Pay', value: 'Express Pay' },
    { label: 'Sent to ADM', value: 'Sent to ADM' },
    { label: 'Charge Created', value: 'Charge Created' },
    { label: 'Charge Updated', value: 'Charge Updated' },
    { label: 'Claim Submitted', value: 'Claim Submitted' },
    { label: 'AP/MR Submitted', value: 'AP/MR Submitted' },
    { label: 'Claim Response', value: 'Claim Response' },
    { label: 'Claim Denied', value: 'Claim Denied' },
    { label: 'Claim Paid', value: 'Claim Paid' },
    { label: 'Invoice Pending', value: 'Invoice Pending' },
    { label: 'Invoice Processing', value: 'Invoice Processing' },
    { label: 'Invoiced', value: 'Invoiced' },
    { label: 'Invoice Paid', value: 'Invoice Paid' },
    { label: 'Write Off', value: 'Write Off' },
  ]

  billingSubStatusList: any[] = [];

  labStatusList: any[] = [
    { label: 'Completed', value: 'Completed' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Processing', value: 'Processing' },
    { label: 'In Transit to Lab', value: 'In Transit to Lab' },
  ]
  dontLazyLoad: boolean = false;

  async ngOnInit() {
    this.loading = true;

    this.cols = [
      { field: 'Eye', header: '.', filter: '', sortable: false, width: '2%' },
      { field: 'BillingStatus', header: 'Bill Status', filter: '', sortable: true, width: '9%' },
      { field: 'Accession', header: 'SID', filter: '', sortable: true, width: '9%' },
      { field: 'PatientName', header: 'Patient Name', filter: '', sortable: true, width: '5%' },
      { field: 'ClientName', header: 'Client', filter: '', sortable: true, width: '5%' },
      { field: 'BirthDate', header: 'DOB', filter: '', sortable: true, width: '4%' },
      { field: 'LabPanelName', header: 'Test', filter: '', sortable: true, width: '19%' },
      { field: 'DateOfService', header: 'DOS', filter: '', sortable: true, width: '4%' },
      { field: 'DateCompleted', header: 'Resulted', filter: '', sortable: true, width: '4%' },
      { field: 'InsuranceList', header: 'Insurance', filter: '', sortable: true, width: '30%' },
      { field: 'LabStatus', header: 'Lab Status', filter: '', sortable: true, width: '9%' },
      { field: 'BillingSubStatus', header: 'SubStatus', filter: '', sortable: true, width: '9%' },
    ];
    this.filters = {
      'BillingStatus': [{ value: null, matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
      'BillingSubStatus': [{ value: null, matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
      'Accession': [{ value: null, matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
      'PatientName': [{ value: null, matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
      'ClientName': [{ value: null, matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
      'BirthDate': [{ value: null, matchMode: FilterMatchMode.DATE_IS, operator: 'and' }],
      'LabPanelName': [{ value: null, matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
      'DateOfService': [{ value: null, matchMode: FilterMatchMode.DATE_AFTER, operator: 'and' }],
      'DateCompleted': [{ value: "2025-09-30T06:00:00.000Z", matchMode: FilterMatchMode.DATE_AFTER, operator: 'and' }],
      'InsuranceList': [{ value: null, matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
      'LabStatus': [{ value: "Completed", matchMode: FilterMatchMode.EQUALS, operator: 'and' }],
    };

    this.billingSubStatusList = [];
    this.billingDataService.getSubstatuses().subscribe((data: any) => {
      for (const s of data) {
        this.billingSubStatusList.push({ label: s, value: s });
      }    
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error Loading Substatus List ', detail: 'Failed: ' + err.error });
    });

    this.loading = true;
  }


  public applyGlobalFilter(value: string, reqlist) {
    reqlist.filterGlobal(value, 'contains');
  }

  public dropdownFilter(filter: (a: string) => void, value: string) {
    this.dontLazyLoad = true;
    filter(value);
    this.dontLazyLoad = false;
  }

  public multiSelectFilter(filter: (a: string) => void, value: string) {
    this.dontLazyLoad = true;
    filter(value);
    this.dontLazyLoad = false;
  }

  public loadRequisitionsLazy(event: LazyLoadEvent) {
    if (this.dontLazyLoad) {
      return;
    }
    this.loading = true;
    this.billingDataService.getList(event).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.requisitions = data.rows;
      this.loading = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error Loading List ', detail: 'Failed: ' + err.error });
      this.totalRecords = 0;
      this.requisitions = [];
      this.loading = false;
    });
  }

  clear(table: Table) {
    table.clear();
    this.filters['DateCompleted'] = [{ value: "2025-09-30T06:00:00.000Z", matchMode: FilterMatchMode.DATE_AFTER, operator: 'and' }];
    this.filters['LabStatus'] = [{ value: "Completed", matchMode: FilterMatchMode.EQUALS, operator: 'and' }];

  }

  public updateBillingStatus(event) {
    console.log('list received update ', event);
    var req = this.requisitions.find(r => r.Id === event.RequisitionId);
    if (req) {
      req.BillingStatus = event.Status;
    }
  }
}
